'use strict';
import { module } from '../app';
import * as _ from 'lodash';
import { constantStrings } from "../constants/constantStrings";
import { convertSvgToPng } from "../services/svgToPngImageConvert";

module
  .factory('findingsViewModel', [
    'localStorage', 'Diagram', 'modalService', 'eventsMgr', '$ionicLoading', 'techpadConfig',
    '$q',
    function (localStorage, Diagram, modalService, eventsMgr, $ionicLoading, techpadConfig,
              $q) {
      let vm = function (worklistId, scope) {
        let self = this;
        self.worklistId = worklistId;
        self._scope = scope;


        self.problemsDefaultConfig = [
          {value: 'Scar', icon: 'ion-scar', draggable: false, label: 'Scar'},
          {value: 'Mole', icon: 'ion-record', draggable: true, label: 'Mole'},
          {value: 'Lump', icon: 'ion-ios-circle-outline', draggable: true, label: 'Lump'},
          {value: 'Square', icon: 'ion-ios-square-outline', draggable: true, label: 'Square'},
          {value: 'Pain', icon: 'ion-pain', draggable: true, label: 'Pain'},
          {value: 'Star', icon: 'ion-ios-star-outline', draggable: true, label: 'Pain/Lump'},
          {value: 'Square', icon: 'ion-ios-square-outline', draggable: true, label: 'Square'},
          {value: 'Mastectomy', icon: 'ion-m-letter', draggable: true, label: 'Mastectomy'},
          {value: 'ReductionScar', icon: 'ion-reduction-scar', draggable: true, label: 'Reduction Scar'},
          {value: 'CircularScar', icon: 'ion-circular-scar', draggable: true, label: 'Circular Scar'},
          {value: 'Label', icon: 'fa fa-font', draggable: true, label: 'Label'},
        ];

        self.problems = self.problemsDefaultConfig;
        self.diagramSettings = techpadConfig.settings.DiagramSettings;

        self.initConfig = function (problemsConfig) {
          if (!problemsConfig || !problemsConfig.length) {
            return;
          }

          self.problems = _.map(_.filter(problemsConfig, {Enabled: true}), function (p) {
            let problemModel = angular.copy(_.find(self.problemsDefaultConfig, {value: p.Type}));
            problemModel.label = p.Label || problemModel.label;
            return problemModel;
          });
        };

        self.enableEditing = function () {
          scope.findingEditing = true;
          if (!self.findingFullscreen) {
            self.toggleDiagramFullscreen()
          }

          setTimeout(() => {
            //console.log('disable scrolling');
            document.ontouchmove = function (e) {
              e.preventDefault();
              return false;
            };
          }, 500);
        };

        self.disableEditing = function () {
          scope.findingEditing = false;
        };

        self.initConfig(techpadConfig.settings.DiagramSettings);
        //[
        //{ type: 'Scar' },
        //{ type: 'Mole', label: 'Mole 12' }
        //]
        //);

        self.mode = '';

        self.turnMode = function (m) {
          if (self.mode === m) {
            self.mode = '';
            return;
          }

          if (m === 'ReductionScar') {
            if (self._scope.problemsList.filter(x => x.Type === m).length === 2) {
              self.mode = '';
              modalService.showAlert(constantStrings.errorMessages.cannotDrawMoreReductionScars);
              return;
            }
          }

          if (m === 'Mastectomy') {
            if (self._scope.problemsList.filter(x => x.Type === m).length === 2) {
              self.mode = '';
              modalService.showAlert(constantStrings.errorMessages.cannotDrawMoreMastectomies);
              return;
            }
          }
          self.mode = m;
        };

        self.getLabel = function (type) {
          return _.find(self.problems, {value: type}).label;
        };

        self.getMode = function () {
          return self.mode;
        };

        self.drawScar = function (result) {
          if (result.path.length < 3) {
            return;
          }

          let pos = result;
          let type = 'Scar';

          self._scope.problemsList.push({Settings: pos, Type: type});
          self.mode = '';
        };

        self.addProblem = function (type, pos) {
          let problemItem = {Settings: pos, Type: type};

          self._scope.problemsList.push(problemItem);

          self.problems = angular.copy(self.problems);
          self.mode = '';
        };


        self.dropped = function (el, pos) {
          let type = angular.element(el).scope().el.value;

          self.addProblem(type, pos);
        };

        self.setDiagramEditor = function (diagramEditor) {
          self._scope.setDiagramEditor(diagramEditor);
        };

        self.save = async function (svg, needSave) {
          self.setSvgAction(svg);

          if (needSave) {
            const base64String = await convertSvgToPng(svg);
            if (self.saveDiagramAction) {
              return await self.saveDiagramAction(base64String);
            }
          }
        };

        self.clear = function () {
          Diagram.save(self.worklistId, { Problems: [], IsDiagramChanged: true, IsDiagramEmpty: true });
          self._scope.problemsList = [];
          self.clearConfirmationVisible = false;
        };

        self.diagramClearProblemSelection = eventsMgr.on('diagram:clearProblemSelection', function (scope) {
          self.turnMode(self.mode);
        });

        scope.$on('$destroy', function () {
          self.diagramClearProblemSelection.unsubscribe();
        });

        self.startClearing = function () {
          self.turnMode(self.mode); // clear current selection
          modalService.showConfirmation(function () {
            self.clear()
          }, 'Are you sure to clear diagram?');
        };

        self.editComment = function () {
          modalService.showCommentsInputWindow(self.selectedElement.Comments).then(function (comment) {
            self.selectedElement.Comments = comment;
          })
        };

        self.removeComment = function (item) {
          modalService.showConfirmation(function () {
            item.Comments = null;
          }, 'Are you sure you want to delete this comment?');
        };


        let diagramEditorOnReadyToSave = eventsMgr.on('diagram:fullscreen', function (params, value) {
          self.findingFullscreen = value;
        });

        self.toggleDiagramFullscreen = function () {
          self.findingFullscreen = !self.findingFullscreen;
          eventsMgr.send('diagram:fullscreen', self.findingFullscreen);
        };
      };

      return vm;
    } ]);



// WEBPACK FOOTER //
// ./src/scripts/models/findings.js